import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import skeletonLibCss from 'react-loading-skeleton/dist/skeleton.css?inline';
import skeletonStylesCss from './assets/styles/skeleton.styles.scss?inline';

import {
    borderStyleSkeleton,
    color,
    costs,
    duration,
    financings,
    highlightColor,
    selectors,
} from './components/Skeleton/skeleton.constants';

const injectStyle = (id: string, css: string) => {
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = css;
    document.head.appendChild(style);
};

/**
 * This class build the skeleton-loader component for the
 * initial data loaded in the widget. It works with a skeleton
 * package for react, this package offer a base of figures to
 * build your screen.
 */
export class SkeletonLoader extends React.PureComponent {
    constructor(props: object) {
        super(props);
        injectStyle('mfc-skeleton-lib', skeletonLibCss);
        injectStyle('mfc-skeleton-styles', skeletonStylesCss);
    }

    private readonly heigthOfThree = 3;
    private readonly heigthOfTwenty = 20;
    private readonly heigthOfThirty = 30;
    private readonly heigthOfForty = 40;

    public render() {
        return (
            <section className='skeleton-section'>
                <div>
                    <div className='title-text'>
                        <div>
                            <SkeletonTheme
                                baseColor={color}
                                highlightColor={highlightColor}
                            >
                                <p>
                                    <Skeleton
                                        {...borderStyleSkeleton}
                                        duration={duration}
                                        height={this.heigthOfTwenty}
                                        width='100%'
                                    />
                                </p>
                            </SkeletonTheme>
                        </div>
                    </div>

                    <div className='summary-text'>
                        <div>
                            <SkeletonTheme
                                baseColor={color}
                                highlightColor={highlightColor}
                            >
                                <p>
                                    <Skeleton
                                        {...borderStyleSkeleton}
                                        duration={duration}
                                        height={this.heigthOfTwenty}
                                        width='100%'
                                    />
                                </p>
                            </SkeletonTheme>
                        </div>
                    </div>

                    <div className='text-lg'>
                        <div>
                            <SkeletonTheme
                                baseColor={color}
                                highlightColor={highlightColor}
                            >
                                <p>
                                    <Skeleton
                                        {...borderStyleSkeleton}
                                        duration={duration}
                                        height={this.heigthOfForty}
                                        width='100%'
                                    />
                                </p>
                            </SkeletonTheme>
                        </div>
                    </div>

                    <div className='title-financial-products'>
                        <div>
                            <SkeletonTheme
                                baseColor={color}
                                highlightColor={highlightColor}
                            >
                                <p>
                                    <Skeleton
                                        {...borderStyleSkeleton}
                                        duration={duration}
                                        height={this.heigthOfTwenty}
                                        width='100%'
                                    />
                                </p>
                            </SkeletonTheme>
                        </div>
                    </div>

                    <div className='container-financial-products'>
                        {financings.map((item, index) => (
                            <div
                                className='child-financial-products'
                                key={index}
                            >
                                <SkeletonTheme
                                    baseColor={color}
                                    highlightColor={highlightColor}
                                >
                                    <p>
                                        <Skeleton
                                            {...borderStyleSkeleton}
                                            duration={duration}
                                            height={item.height}
                                            width={item.width}
                                        />
                                    </p>
                                </SkeletonTheme>
                            </div>
                        ))}
                    </div>

                    {selectors.map((item, index) => (
                        <div
                            key={index}
                            style={{ marginTop: item.marginTop }}
                            className='container-selector'
                        >
                            <div className={item.class}>
                                <SkeletonTheme
                                    baseColor={color}
                                    highlightColor={highlightColor}
                                >
                                    <p>
                                        <Skeleton
                                            {...borderStyleSkeleton}
                                            duration={duration}
                                            height={item.height}
                                            width='100%'
                                        />
                                    </p>
                                </SkeletonTheme>
                            </div>

                            <div className={`${item.class}`}>
                                <SkeletonTheme
                                    baseColor={color}
                                    highlightColor={highlightColor}
                                >
                                    <p>
                                        <Skeleton
                                            {...borderStyleSkeleton}
                                            duration={duration}
                                            height={item.height}
                                            width='100%'
                                        />
                                    </p>
                                </SkeletonTheme>
                            </div>
                        </div>
                    ))}

                    <div className='separator-line'>
                        <div>
                            <SkeletonTheme
                                baseColor={color}
                                highlightColor={highlightColor}
                            >
                                <p>
                                    <Skeleton
                                        {...borderStyleSkeleton}
                                        duration={duration}
                                        height={this.heigthOfThree}
                                        width='100%'
                                    />
                                </p>
                            </SkeletonTheme>
                        </div>
                    </div>

                    <div className='container-totals'>
                        <div className='child-container-totals'>
                            {costs.map((item, index) => (
                                <div
                                    className={item.class}
                                    key={index}
                                    style={{ marginTop: item.marginTop }}
                                >
                                    <div>
                                        <SkeletonTheme
                                            baseColor={color}
                                            highlightColor={highlightColor}
                                        >
                                            <p>
                                                <Skeleton
                                                    {...borderStyleSkeleton}
                                                    duration={duration}
                                                    height={item.height}
                                                    width='100%'
                                                />
                                            </p>
                                        </SkeletonTheme>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className='child-container-totals'>
                            <div className='child-container-totals-item'>
                                <div>
                                    <SkeletonTheme
                                        baseColor={color}
                                        highlightColor={highlightColor}
                                    >
                                        <p>
                                            <Skeleton
                                                {...borderStyleSkeleton}
                                                duration={duration}
                                                height={this.heigthOfThirty}
                                                width='100%'
                                            />
                                        </p>
                                    </SkeletonTheme>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
